import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const createConnectOrderControl: DomainAccessControlConfig = {
  permissions: [Permission.ConnectOrdersModify],
  warehouseFeatureToggles: [FeatureToggle.createConnectOrder],
}
